import { createContext, useContext } from 'react';

export interface SidebarToggleContextType {
  isOpen: boolean;
  toggleSidebar: () => void;
}

export interface SidebarDataContextType {
  invalidateConversations: () => void;
  activePreviewId: string | null;
  setActivePreviewId: (id: string | null) => void;
  urlWorkspaceId: string | null;
  urlChatId: string | null;
}

export const SidebarToggleContext = createContext<SidebarToggleContextType | null>(null);
export const SidebarDataContext = createContext<SidebarDataContextType | null>(null);

export function useSidebarToggle() {
  const context = useContext(SidebarToggleContext);
  if (!context) {
    throw new Error('useSidebarToggle must be used within SidebarProvider');
  }
  return context;
}

export function useSidebarData() {
  const context = useContext(SidebarDataContext);
  if (!context) {
    throw new Error('useSidebarData must be used within SidebarProvider');
  }
  return context;
}

export function useSidebar() {
  return { ...useSidebarToggle(), ...useSidebarData() };
}
